import { render, staticRenderFns } from "./returnVisit.vue?vue&type=template&id=2be34d3a&"
import script from "./returnVisit.vue?vue&type=script&lang=js&"
export * from "./returnVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be34d3a')) {
      api.createRecord('2be34d3a', component.options)
    } else {
      api.reload('2be34d3a', component.options)
    }
    module.hot.accept("./returnVisit.vue?vue&type=template&id=2be34d3a&", function () {
      api.rerender('2be34d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/returnVisitQuery/returnVisit.vue"
export default component.exports